<template>
  <v-tabs grow v-model="tab" show-arrows>
    <v-tab>Notification</v-tab>
    <v-tab>News</v-tab>
    <v-tab>Events</v-tab>

    <v-tabs-items v-model="tab">
      <!-- Notifications     -->
      <v-tab-item>
        <v-list dense>
          <v-list-item-group>
            <v-list-item two-line>
              <!-- <v-list-item-action>
                <v-icon color="success">mdi-check-circle</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Payment Received</v-list-item-title>
                <v-list-item-subtitle>
                  Your payment for 2022 renewal has been received
                </v-list-item-subtitle>
              </v-list-item-content> -->
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-tab-item>

      <!-- News     -->
      <v-tab-item>
        <v-card tile>
          <v-img
            height="250"
            src="https://kiseb.or.ke/wp-content/uploads/2021/05/image-526x526.png"
          ></v-img>

          <v-card-title>KISEB Accreditation by KNQA</v-card-title>

          <v-card-text>
            <div class="my-2 overline">SEPTEMBER 21, 2021</div>

            <div class="caption">
              Dr. Juma Mukhwana ( Director General, KNQA), Dr. Fred Ongisa (Ag.
              Secretary/CEO, KISEB), Ms. Linda Susan Ingari ( KISEB Board Member
              & Chair of CDEQA Committee), Hon. Dr. Kilemi Mwiria (Chairman,
              KNQA)during the presentation of Certificate of Accreditation to
              KISEB qualifications (CPSP-K and APS-K)..
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary lighten-2"
              text
              href="https://kiseb.or.ke/kiseb-accreditation-by-knqa-2/"
              target="_blank"
            >
              Read More
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>

      <!-- Events     -->
      <v-tab-item>
        <v-card tile>
          <v-img
            src="https://kiseb.or.ke/wp-content/uploads/2021/10/Bunner.jpeg"
            height="200px"
            contain
          >
            <v-overlay absolute>
              <v-card-title class="white--text pa-5">
                <div
                  class="text-h6 text-center text-uppercase font-weight-bold"
                >
                  Launch of the Revised CPSP-K & APS-K Syllabuses
                </div>
              </v-card-title>
            </v-overlay>
          </v-img>
          <v-card-text class="pa-5 caption">
            KISEB is proud to announce the launch of the revised Certified
            Procurement and Supply Professional of Kenya (CPSP-K) and Associate
            in Procurement and Supply of Kenya (APS-K) on Friday October 8th,
            2021 from 8.00am – 11:00am at Hilton Hotel, Nairobi.
          </v-card-text>
          <v-card-actions class="primary darken-4 overline white--text">
            October 8th, 2021
            <v-spacer />

            <v-btn
              small
              text
              color="white"
              href="https://kiseb.or.ke/launch-of-the-revised-cpsp-k-aps-k-syllabuses/"
              target="_blank"
            >
              View
              <v-icon right>mdi-arrow-right</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-tabs>
</template>

<script>
export default {
  name: "InfoSection",
  data: function () {
    return {
      tab: 0,
    };
  },
};
</script>

<style scoped></style>
